import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = {
  key: 0,
  class: "offcanvas-header"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = { class: "offcanvas-body" }
const _hoisted_6 = { class: "offcanvas-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    id: this.id,
    class: `offcanvas ${this.position} ${this.class}`,
    "aria-labelledby": this.label,
    tabindex: "-1"
  }, this.attributes), [
    (this.customContent)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true),
    (!this.customContent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!this.noHeader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h5", {
                  class: "offcanvas-title",
                  id: this.label
                }, _toDisplayString(this.title ?? 'Offcanvas'), 9, _hoisted_3),
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer")
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 16, _hoisted_1))
}